module.exports = {
  1: 'M75,18 l-32,18 M65,13 l-32,18 M55,8 l-32,18',
  2: 'M75,18 l-32,18 M65,13 l-32,18 M55,8 l-32,18',
  3: 'M75,18 l-32,18 M65,13 l-32,18 M55,8 l-32,18',
  12: 'M75,18 l-32,18 M65,13 l-32,18',
  23: 'M65,13 l-32,18 M55,8 l-32,18',
  123: 'M75,18 l-32,18 M65,13 l-32,18 M55,8 l-32,18',
  receding: 'M65,13 l-9,0 m9,0 l-5,8',
  approaching: 'M33,31 l5,-8 m-5,8 l9,0',
  both: 'M65,13 l-9,0 m9,0 l-5,8 M33,31 l5,-8 m-5,8 l9,0',
  receding1: 'M75,18 l-9,0 m9,0 l-5,8 l5,-8 l-32,18',
  receding2: 'M65,13 l-9,0 m9,0 l-5,8 l5,-8 l-32,18',
  receding3: 'M55,8 l-9,0 m9,0 l-5,8 l5,-8 l-32,18',
  receding12: 'M75,18 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 M65,13 l-9,0 m9,0 l-5,8 l5,-8 l-32,18',
  receding23: 'M65,13 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 M55,8 l-9,0 m9,0 l-5,8 l5,-8 l-32,18',
  receding123: 'M75,18 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 M65,13 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 M55,8 l-9,0 m9,0 l-5,8 l5,-8 l-32,18',
  approaching1: 'M75,18 l-32,18 l5,-8 m-5,8 l9,0',
  approaching2: 'M65,13 l-32,18 l5,-8 m-5,8 l9,0',
  approaching3: 'M55,8 l-32,18 l5,-8 m-5,8 l9,0',
  approaching12: 'M75,18 l-32,18 l5,-8 m-5,8 l9,0 M65,13 l-32,18 l5,-8 m-5,8 l9,0',
  approaching23: 'M65,13 l-32,18 l5,-8 m-5,8 l9,0 M55,8 l-32,18 l5,-8 m-5,8 l9,0',
  approaching123: 'M75,18 l-32,18 l5,-8 m-5,8 l9,0 M65,13 l-32,18 l5,-8 m-5,8 l9,0 M55,8 l-32,18 l5,-8 m-5,8 l9,0',
  both1: 'M75,18 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0',
  both2: 'M65,13 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0',
  both3: 'M55,8 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0',
  both12: 'M75,18 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0 M65,13 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0',
  both23: 'M65,13 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0 M55,8 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0',
  both123: 'M75,18 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0 M65,13 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0 M55,8 l-9,0 m9,0 l-5,8 l5,-8 l-32,18 l5,-8 m-5,8 l9,0',
}
